import React from 'react';

export default class NumericTextBox extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		var self = this;

		var opts = {
		}
		if (this.props.decimals !== undefined)
			opts.decimals = this.props.decimals;
		if (this.props.format !== undefined)
			opts.format = this.props.format;
		if (this.props.step !== undefined)
			opts.step = this.props.step;
		if (this.props.min !== undefined)
			opts.min = this.props.min;
		if (this.props.spinners !== undefined)
			opts.spinners = this.props.spinners;
		if (this.props.onChange) {
			var { onChange } = this.props;
			opts.change = () => {
				var control = $(self.refs.theInput).data("kendoNumericTextBox");
				var val = control.value();

				onChange(+ val);
			}
		}


    	$(this.refs.theInput).kendoNumericTextBox(opts);

    if (this.props.initialValue !== undefined){
			var control = $(this.refs.theInput).data("kendoNumericTextBox");
			control.value(this.props.initialValue);
		}
    if (this.props.value !== undefined){
			var control = $(this.refs.theInput).data("kendoNumericTextBox");
			control.value(this.props.value);
		}
		if (this.props.disabled == true) {
			var control = $(this.refs.theInput).data("kendoNumericTextBox");
			control.enable(false);
		}

		if (this.props.width !== undefined) {
			$(this.refs.theInput).data("kendoNumericTextBox").wrapper.width(this.props.width);
		}

	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.initialValue !== this.props.initialValue) {
			var control = $(this.refs.theInput).data("kendoNumericTextBox");
    	if (nextProps.initialValue != undefined)
				control.value(nextProps.initialValue);
			else
				control.value('');
		}

		if (nextProps.disabled !== this.props.disabled) {
			var control = $(this.refs.theInput).data("kendoNumericTextBox");
			if (nextProps.disabled === true)
				control.enable(false);
			else
				control.enable();
		}

		if (nextProps.step !== this.props.step) {
			this.setStep(nextProps.step);
		}

		// if (nextProps.dataSource !== this.props.dataSource)
		// 	$(this.refs.theInput).data("kendoAutoComplete")
		// 		.setDataSource(nextProps.dataSource);
	}

	componentWillUnmount() {
		$(this.refs.theInput).data("kendoNumericTextBox").destroy();
	}

	getValue() {
		return $(this.refs.theInput).data("kendoNumericTextBox").value();
	}

	setValue(v) {
		return $(this.refs.theInput).data("kendoNumericTextBox").value(v);
	}

	setStep(step) {
		var control = $(this.refs.theInput).data("kendoNumericTextBox");
		control.step(step);
	}

  render() {
    return (
      <input ref="theInput" type="number"/>
    );
  }

}

NumericTextBox.propTypes = {
	decimals: React.PropTypes.number,
	format: React.PropTypes.string,
	step: React.PropTypes.number,
	min: React.PropTypes.number,
	value: React.PropTypes.number,
	initialValue: React.PropTypes.number,
	disabled: React.PropTypes.bool,
};
NumericTextBox.defaultProps = {
	disabled : false,
};



// WEBPACK FOOTER //
// ./src/components/react-numerictextbox.jsx